import { Controller } from "stimulus"

// Bugfix 29 (#1402): de compacte oefeningzoeker. Zoekbalk bovenaan, daaronder
// de spiergroepen; een spiergroep openen toont alleen die oefeningen, en de
// zoekterm filtert daarbinnen verder. Pas na "Oefening vervangen" gaat er iets
// naar de server; sluiten of annuleren verandert niets.
//
// Een knop opent hem met:
//   data-action="oefening-vervangen#open"
//   data-oefening-vervangen-url-param="/schema-bouwer/.../vervangen"
//   data-oefening-vervangen-huidig-param="Walking Lunges"
//   data-oefening-vervangen-huidig-id-param="12"
export default class extends Controller {
  static targets = ["dialog", "zoek", "groepen", "groepKop", "groepNaam", "resultaten", "leeg",
                    "formulier", "keuze", "huidig", "nieuw", "bevestig", "fout"]

  connect() {
    this.oefeningen = JSON.parse(this.dialogTarget.dataset.oefeningen || "[]")
      .map((o) => ({ ...o, sleutel: this.normaliseer(o.naam) }))
    this.leegNieuw = this.nieuwTarget.textContent
  }

  open({ params }) {
    this.formulierTarget.action = params.url
    this.huidigId = String(params.huidigId || "")
    this.huidigTarget.textContent = params.huidig || ""
    this.groep = null
    this.kies(null)
    this.zoekTarget.value = ""
    this.foutTarget.classList.add("hidden")
    this.toon()
    this.dialogTarget.showModal()
    this.zoekTarget.focus()
  }

  sluit(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  achtergrond(event) {
    if (event.target === this.dialogTarget) this.dialogTarget.close()
  }

  gesloten() {
    this.kies(null)
  }

  zoek() {
    this.toon()
  }

  kiesGroep({ params, currentTarget }) {
    this.groep = params.groep
    this.groepNaamTarget.textContent = currentTarget.dataset.groepLabel || params.groep
    this.toon()
    this.zoekTarget.focus()
  }

  terug() {
    this.groep = null
    this.toon()
    this.zoekTarget.focus()
  }

  selecteer({ currentTarget }) {
    this.kies(this.oefeningen.find((o) => String(o.id) === currentTarget.dataset.id))
    this.toon()
  }

  klaar(event) {
    if (event.detail.success) {
      this.dialogTarget.close()
    } else {
      this.foutTarget.classList.remove("hidden")
    }
  }

  // ---- intern ----------------------------------------------------------

  kies(oefening) {
    this.gekozen = oefening
    this.keuzeTarget.value = oefening ? oefening.id : ""
    this.nieuwTarget.textContent = oefening ? oefening.naam : this.leegNieuw
    this.bevestigTarget.disabled = !oefening
  }

  toon() {
    const term = this.normaliseer(this.zoekTarget.value)
    const lijstTonen = term.length > 0 || this.groep
    this.groepenTarget.classList.toggle("hidden", lijstTonen)
    this.groepKopTarget.classList.toggle("hidden", !this.groep)
    if (!lijstTonen) {
      this.resultatenTarget.classList.add("hidden")
      this.leegTarget.classList.add("hidden")
      return
    }

    const treffers = this.oefeningen.filter((o) =>
      String(o.id) !== this.huidigId &&
      (!this.groep || o.groep === this.groep) &&
      (!term || o.sleutel.includes(term)))
    this.resultatenTarget.replaceChildren(...treffers.map((o) => this.regel(o)))
    this.resultatenTarget.classList.toggle("hidden", treffers.length === 0)
    this.leegTarget.classList.toggle("hidden", treffers.length > 0)
  }

  regel(oefening) {
    const li = document.createElement("li")
    const knop = document.createElement("button")
    const gekozen = this.gekozen && this.gekozen.id === oefening.id
    knop.type = "button"
    knop.dataset.id = oefening.id
    knop.dataset.action = "oefening-vervangen#selecteer"
    knop.setAttribute("role", "option")
    knop.setAttribute("aria-selected", gekozen ? "true" : "false")
    knop.className = "w-full flex items-center gap-2 px-3 py-1.5 rounded-md text-left text-sm " +
      (gekozen ? "bg-gray-900 text-white font-medium" : "text-gray-800 hover:bg-gray-100")
    const vink = document.createElement("span")
    vink.className = "w-4 flex-none"
    vink.textContent = gekozen ? "\u2713" : ""
    const naam = document.createElement("span")
    naam.className = "flex-1"
    naam.textContent = oefening.naam
    knop.append(vink, naam)
    if (!this.groep) {
      const groep = document.createElement("span")
      groep.className = gekozen ? "text-xs text-gray-300" : "text-xs text-gray-400"
      groep.textContent = oefening.label || oefening.groep
      knop.append(groep)
    }
    li.append(knop)
    return li
  }

  normaliseer(tekst) {
    return String(tekst || "").normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase().trim()
  }
}
